$.fn.TableOfContents = function() {
  let self = this

  if (self.data('table-of-contents')) {
    return self.data('table-of-contents')
  }

  self.scrolled = function(top) {
    let anchors = $('.row-anchor'),
    currentAnchor = undefined
    anchors.each(function(index, el) {
      if (top > $(el).offset().top - $(window).height() / 2) {
        currentAnchor = $(el)
      }
    })
    $('.table-of-contents__item--current-anchor').removeClass('table-of-contents__item--current-anchor')
    if (currentAnchor != undefined) {
      $('.table-of-contents__item[data-anchor="' + currentAnchor.attr('id') + '"]').addClass('table-of-contents__item--current-anchor')
    }
  }

  self.setupExtendedMenu = function(element) {
    if (self.find('.table-of-contents__extended').length < 1) {
      var extended = $('<div class="table-of-contents__extended"></div>');
      var extended_button = $('<button class="table-of-contents__extended__button"><i class="icon-angle"></i></button>');
      var extended_list = $('<ul class="table-of-contents__extended__list"></ul>');
      extended.append(extended_button)
      extended.append(extended_list)
      self.append(extended);
    }
    self.find('.table-of-contents__extended__list').append(element.clone())
    element.addClass('--in-extended-menu')
  }

  self.resetExtendedMenu = function(element) {
    self.find('.--in-extended-menu').removeClass('--in-extended-menu')
    self.find('.table-of-contents__extended').remove()
  }

  return function() {
    $(window).on('resize load orientationchange', function() {
      self.resetExtendedMenu();
      var container = self.find('.container');
      var container_end = container.position().left + container.width() - 50;
      self.find('.table-of-contents__item').each(function() {
        var el_end = $(this).position().left + $(this).outerWidth()
        if (el_end > container_end) {
          self.setupExtendedMenu($(this))
        }
      })
    })
    $(window).ScrollEvents().add(self.scrolled)
    self.FixedContent({
      mobile: true,
      fixedClass: '--fixed',
      pushedClass: '--pushed',
    })
    self.on('content_fixed', function() {
      if (self.hasClass('--fixed')) {
        $('body').addClass('--toc-fixed')
      } else {
        $('body').removeClass('--toc-fixed')
      }
    })
    self.find('.table-of-contents__item').each(function() {
      if (!$('.row-anchor' + $(this).find('a').attr('href')).length) {
        $(this).remove()
      }
    })
    self.data('table-of-contents', self)
    return self
  }()
}
